<template>
  <div
    class="lg:px-7.5 h-13 border-b-1 flex justify-between border-neutral-100 bg-white px-2 pb-1.5 pt-1.5 shadow-lg shadow-neutral-200/30 dark:border-neutral-800 dark:bg-neutral-900 dark:shadow-none md:px-4"
  >
    <div class="flex items-center">
      <NavigationMenu
        v-if="$windowSize.isDesktop"
        class="rounded-lg bg-gray-100 dark:bg-neutral-800"
        item-active-class="btn-primary"
        item-class="btn py-2.5 px-4 hover:bg-gray-200 dark:hover:bg-neutral-700"
      ></NavigationMenu>
      <Dropdown
        v-if="$windowSize.isTablet"
        :fullscreen="true"
        button-class="btn py-2.5 px-4.5 group bg-gray-100 dark:bg-neutral-800 hover:bg-gray-200 dark:hover:bg-neutral-700 w-40"
      >
        >
        <template #label-icon>
          <lucide-icon
            icon="Menu"
            class="text-primary group-hover:text-primary-active me-2"
            size="16"
          />
        </template>
        <template #label>
          {{ $t('control.Change view') }}
        </template>
        <template #title> {{ $t('control.Change view') }}</template>
        <template #content="{ closeDropdown }">
          <NavigationMenu
            class="flex-col"
            item-active-class="btn-primary"
            item-class="btn h-10 md:h-9 px-3 hover:bg-gray-100 dark:hover:bg-neutral-700"
            @pageChanged="closeDropdown"
          ></NavigationMenu>
        </template>
      </Dropdown>
    </div>

    <div class="flex items-center justify-end">
      <div v-if="!hideContacts" class="hidden flex-col justify-end lg:flex">
        <div v-if="catalogSettings?.contacts.phone" class="flex items-center">
          <lucide-icon
            icon="PhoneCall"
            size="16"
            class="text-primary me-3"
          ></lucide-icon>
          <div class="flex flex-col text-end">
            <a
              v-if="mainPhone"
              class="hover:text-primary text-xl leading-5 transition-colors"
              :href="'tel:' + catalogSettings?.contacts.phone"
            >
              {{ mainPhone }}
            </a>
            <a
              v-if="secondaryPhone"
              class="hover:text-primary text-lg leading-4 transition-colors"
              :href="'tel:' + catalogSettings?.contacts.secondary_phone"
            >
              {{ secondaryPhone }}
            </a>
          </div>
        </div>
        <a
          v-if="
            !secondaryPhone &&
            catalogSettings?.allow_requests &&
            !inCrmApplication
          "
          class="leading-2 text-primary hover:text-primary-active mt-1 text-end text-xs"
          href="#"
          @click.prevent="
            OPEN_MODAL({
              type: 'callback',
            })
          "
        >
          {{ $t('control.callback') }}
        </a>
      </div>
      <div
        v-if="
          (!hideSocials && catalogSettings?.contacts.links.length > 0) ||
          (!hideContacts && $windowSize.isTablet)
        "
        v-hint="{
          position: 'bottom-center',
          yOffset: 8,
          text: $t('titles.Contact'),
          showDelay: 600,
        }"
        class="ms-2"
      >
        <LinksDropdown
          :button-class="`btn ${
            $windowSize.isTablet ? 'btn-primary bg-primary' : ''
          } btn-icon w-10 h-10 text-primary bg-gray-100 dark:bg-neutral-800 hover:bg-gray-200 dark:hover:bg-neutral-700`"
        ></LinksDropdown>
      </div>
      <router-link
        v-if="
          catalogSettings?.type != 'GroupInteractiveCatalogue' &&
          isTokenLoaded &&
          !hideFav
        "
        v-hint="{
          position: 'bottom-center',
          yOffset: 8,
          text: $t('routes.Favorites'),
          showDelay: 600,
        }"
        :to="
          getRouterConfig({
            name: 'Favorites',
          })
        "
        :inert="$route.name.startsWith('Favorites')"
        active-class="btn-primary"
        class="btn group ms-1 ms-2 h-10 w-10 items-center justify-center bg-gray-100 hover:bg-gray-200 dark:bg-neutral-800 dark:hover:bg-neutral-700"
      >
        <lucide-icon
          icon="RPTHeart"
          size="20"
          :badge="favorites.length"
          class="group-not-[.btn-primary]:text-primary transition-transform group-hover:scale-105"
        />
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import NavigationMenu from './NavigationMenu.vue';
import LinksDropdown from './LinksDropdown.vue';
import Dropdown from '@/components/ui/Dropdown';
import { formatPhoneNumber } from '@dmlnc/hello_world_phone';
import Hint from '@/libs/directives/Hint';

export default {
  name: 'HeaderBottom',

  components: {
    NavigationMenu,
    LinksDropdown,
    Dropdown,
  },
  directives: {
    Hint,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'isTokenLoaded',
      'favorites',
      'catalogSettings',
      'inCrmApplication',
      'hideContacts',
      'hideSocials',
      'hideFav',
    ]),

    mainPhone() {
      return formatPhoneNumber(this.catalogSettings?.contacts.phone);
    },
    secondaryPhone() {
      return formatPhoneNumber(this.catalogSettings?.contacts.secondary_phone);
    },
  },
  watch: {
    // async catalogSettings() {},
  },

  async mounted() {},

  beforeDestroy() {
    // window.removeEventListener('resize', this.onResize);
    // if (this.interval != null) {
    //   clearInterval(this.interval);
    //   this.interval = null;
    // }
  },

  methods: {
    ...mapActions([
      'OPEN_MODAL',
      // 'CHANGE_LANG',
      // 'TOGGLE_FILTER',
      // 'LOAD_START',
      // 'OPEN_PROJECT',
      // 'OPEN_ORDER_MODAL',
    ]),
  },
};
</script>
<style lang="scss"></style>
